import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { openExternalUrl } from '../../utils/webview/messages';

const getSessionWebUrl = (sessionId: string, station?: string) => {
    const isGov =
        process.env.REACT_APP_ENVIRONMENT === 'gov' ||
        process.env.REACT_APP_ENVIRONMENT === 'GOV';

    const isStaging =
        process.env.REACT_APP_ENVIRONMENT === 'staging' ||
        process.env.REACT_APP_ENVIRONMENT === 'STAGING';

    const host = isGov
        ? 'https://access.fed.chargie.com'
        : isStaging
          ? 'https://access.staging.chargie.com'
          : 'https://access.chargie.com';
    if (station) {
        return `${host}/session/${sessionId}/${station}`;
    }
    return `${host}/session/${sessionId}`;
};

/**
 * Handles /session/:sessionId deeplinks for guests / logged-out users.
 * Opens the matching web session URL in the system browser, then leaves
 * the in-app SessionPage alone (no activeChargieId required).
 */
const SessionDeepLinkPage = () => {
    const { sessionId, station } = useParams<{
        sessionId: string;
        station?: string;
    }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (sessionId) {
            openExternalUrl(getSessionWebUrl(sessionId, station));
        }
        navigate('/', { replace: true });
    }, [sessionId, station, navigate]);

    return null;
};

export default SessionDeepLinkPage;
